import styled from "styled-components";

export const EnableSourceFormStyled = styled.div<{ maxHeight?: string }>`
  .scroll-sec {
    height: calc(100vh - 238px);
    overflow-y: auto;
  }
`;
